(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GlobalApprovalPolicy', GlobalApprovalPolicy);

    GlobalApprovalPolicy.$inject = ['$resource'];

    function GlobalApprovalPolicy ($resource) {
        var resourceUrl =  'api/orgId/:orgId/global-approval-policy/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'}
        	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getGlobalApprovalPolicies': {
                 method: 'GET',
                 isArray: true,
                 url: 'api/global-approval-policy/orgTypeId/:orgTypeId/customerUserTypeId/:customerUserTypeId',
                 params: {orgTypeId:'@orgTypeId',customerUserTypeId:'@customerUserTypeId'},
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'save': {
                 method: 'POST',
                 url: 'api/global-approval-policy/orgTypeId/:orgTypeId/custUserTypeId/:custUserTypeId',
                 params: {orgTypeId:'@orgTypeId',custUserTypeId:'@custUserTypeId'},
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                    return angular.toJson(copy);
                 }                
             },
        	 'update': {
                 method: 'PUT',
                 url: 'api/global-approval-policy/orgTypeId/:orgTypeId/custUserTypeId/:custUserTypeId',
                 params: {orgTypeId:'@orgTypeId',custUserTypeId:'@custUserTypeId'},
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/global-approval-policy',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();
